// extracted by mini-css-extract-plugin
module.exports = {"SettingsSection":"CallsSettings_SettingsSection__2UrWV","settingsTitle":"CallsSettings_settingsTitle__1eVv8"};